<template lang="pug">
.comment-form.comment-form-wrap( v-cloak )
  h3( v-if='first') Be the first!
  h3( v-else ) Leave a comment

  alert.alert-success( v-if='submitted' role='alert' )
    | Thank you. Your comment has been submitted!

  div( v-if='!submitted' )
    .form-group
      label( for='commenter' ) Name
      input(
        v-model='commenter'
        class='form-control'
        :class="{ 'is-invalid' : commenter == '' && commenterBlured }"
        @blur='commenterBlured = true'
      )
      .invalid-feedback
        | This is required
    .form-group
      label( for='email' ) Email address
      input(
        v-model='email'
        class='form-control'
        :class="{ 'is-invalid' : !validEmail(email) && emailBlured }"
        @blur='emailBlured = true'
      )
      .invalid-feedback A valid email is required
    .form-group
      label( for='website' )
        | Website
        i (optional)
      input( v-model='website' class='form-control' )
    .form-group
      label( for='content' ) Comment
      textarea(
        v-model='content'
        class='form-control'
        :class="{ 'is-invalid' : content == '' && contentBlured }"
        @blur='contentBlured = true'
      )
      .invalid-feedback
        | This is required
    .form-group
      a( type='submit' href='#'
         class='btn btn-lg btn-success'
         @click.stop.prevent='submit' ) Submit
</template>

<script lang="js">
import axios from 'axios'

export default {
  name: 'comment-form',
  mixins: [],
  components: {},
  props: {
    first: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commenter: '',
      commenterBlured: false,
      email: '',
      emailBlured: false,
      website: '',
      content: '',
      contentBlured: false,
      valid: false,
      submitted: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    validEmail( email ) {
      var re = /\S+@\S+/
      return re.test( email.toLowerCase() )
    },
    validate() {
      this.commenterBlured = true
      this.emailBlured = true
      this.contentBlured = true

      if ( this.commenter !== '' &&
           this.validEmail(this.email ) &&
           this.content !== '' ) {
        this.valid = true
      }
    },
    submit() {
      var self = this
      self.validate()
      if ( self.valid ) {
        axios.post( '/wp-json/wp/v2/comments', {
          author_name: self.commenter,
          author_email: self.email,
          content: self.content,
          author_url: self.website,
          post: self.$parent.post[0].id
        }).then( function ( response ) {
          self.submitted = true
        }).catch( function ( error ) {
          console.log(error)
        })
      }
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.comment-form {

}
</style>
